import React from "react";
import { Capacitor } from "@capacitor/core";
import GoogleButton from "./GoogleButton"; // Web version with callback function
import NativeGoogleButton from "./NativeGoogleButton"; // Mobile version with custom styling
import { googleLogin } from "./socialLoginUtility"; // Mobile OAuth2 flow
import * as Sentry from "@sentry/react";

const PlatformAwareGoogleButton = ({ theme = "light", disabled = false }) => {
  const isNative = Capacitor.isNativePlatform();

  // Mobile handler - uses OAuth2 flow
  const handleMobileGoogleLogin = async () => {
    try {
      const result = await googleLogin();
      if (result.success) {
        console.log("Google login successful on mobile");
      } else {
        console.error("Google login failed on mobile:", result.error);
      }
    } catch (error) {
      console.error("Google login error on mobile:", error);
      Sentry.captureException(error);
    }
  };

  if (isNative) {
    // Mobile: Use UnifiedGoogleButton with socialLoginUtility
    return (
      <NativeGoogleButton
        onClick={handleMobileGoogleLogin}
        theme={theme}
        disabled={disabled}
      />
    );
  } else {
    // Web: Use GoogleButton with Google Identity Services (callback function)
    return <GoogleButton />;
  }
};

export default PlatformAwareGoogleButton;
